import * as Sentry from '@sentry/react';
import type { CurrentUser } from '@wundo/client/auth.ts';

/**
 * Start recording once the visitor is known to be signed in, so anonymous
 * pages are never recorded or buffered. Our own organisation is left out: its
 * day-to-day use is not what the replays are for. The sample rates come from
 * `Sentry.init`.
 */
export function startSessionReplay(user: CurrentUser): void {
  if (import.meta.env.VITE_ENVIRONMENT !== 'prod') return;
  if (user.organisation?.type === 'internal') return;
  if (Sentry.getReplay()) return;

  Sentry.addIntegration(Sentry.replayIntegration());
}
